import Vue from "vue";
import moment from "moment";

const isYesterday = timestamp => {
  // const now = new Date();
  const serverTime = sessionStorage.getItem("serverTime");
  const yesterday = new Date(serverTime - 1000 * 60 * 60 * 24);
  timestamp = new Date(timestamp);
  if (
    yesterday.getYear() === timestamp.getYear() &&
    yesterday.getMonth() === timestamp.getMonth() &&
    yesterday.getDate() === timestamp.getDate()
  ) {
    return true;
  }
  return false;
};

const formatTimeStamp = (timestamp, format = "YYYY-MM-DD") => {
  const serverTime = sessionStorage.getItem("serverTime");
  if (!timestamp) {
    return "";
  }

  if (
    new Date(timestamp).toDateString() ===
      new Date(Number(serverTime)).toDateString() ||
    serverTime < timestamp
  ) {
    format = "HH:mm:ss";
    return moment(timestamp).format(format);
  }
  if (isYesterday(timestamp)) {
    format = "HH:mm:ss";
    return "昨天 " + moment(timestamp).format(format);
  }
  return moment(timestamp).format(format);
};

const dayFirstTime = (timestamp, format = "MM-DD") => {
  const serverTime = sessionStorage.getItem("serverTime");
  if (!timestamp) {
    return "";
  }
  if (
    new Date(timestamp).toDateString() ===
    new Date(Number(serverTime)).toDateString()
  ) {
    // format = "h:mm:ss";
    return "今天";
  }
  if (isYesterday(timestamp)) {
    // format = "h:mm:ss";
    return "昨天";
  }
  return moment(timestamp, "x").format(format);
};

const customerFormatTimeStamp = (timestamp, format = "HH:mm:ss") => {
  if (!timestamp) {
    return "";
  }
  return moment(timestamp, "x").format(format);
};

// const customerFormatTimeStamp = (timestamp, format = "MM-DD hh:mm:ss") => {
//   if (!timestamp) {
//     return "";
//   }
//   const hours = new Date(timestamp).getHours();
//   const timeValue = "" + (hours >= 12 ? "下午 " : "上午 ");
//   if (new Date(timestamp).toDateString() === new Date().toDateString()) {
//     format = "hh:mm:ss";
//     return moment(timestamp, "x").format(format) + " " + timeValue;
//   }
//   if (isYesterday(timestamp)) {
//     format = "hh:mm:ss";
//     return moment(timestamp, "x").format(format) + " " + timeValue;
//   }
//   return moment(timestamp, "x").format(format) + " " + timeValue;
// };

Vue.prototype.formatTimeStamp = formatTimeStamp;
Vue.prototype.customerFormatTimeStamp = customerFormatTimeStamp;
Vue.prototype.dayFirstTime = dayFirstTime;
Vue.filter("datetime", formatTimeStamp);
Vue.filter("customerDatetime", customerFormatTimeStamp);
Vue.filter("dayFirstTime", dayFirstTime);
